import { inject } from "@angular/core";
import { CanMatchFn } from "@angular/router";
import { ModuleStore } from "@core";

export const moduleMatchGuard = (targetModule: string): CanMatchFn => {
  return () => {
    const moduleStore = inject(ModuleStore);
    const currentModule = moduleStore.module();
    
    return currentModule === targetModule;
  };
};